/**
  * @author Marty Cissel

  * @description  The refineStateService gets and sets, using localStorage, 
  *               the state (expanded or !expanded) of search refiners
  *               and platform/publication pitch lists.
  *               The refiners are currently in the websked-vertical-nav
  *               and the pitch lists are in the pitch panel directive.
  */

function refineStateService(localStorageService) {
  function isExpanded(refineName) {
    const expandAtStart = localStorageService.get(`websked.expandAtStart_${refineName}`);
    // null is default, and default is expanded
    return expandAtStart === null || expandAtStart === 'true';
  }

  function curriedSet(refineName) {
    return (newValue) => {
      localStorageService.set(`websked.expandAtStart_${refineName}`, newValue.toString());
    };
  }

  return {
    isExpanded,
    curriedSet
  };
}

const refineStateServiceArray = [
  'localStorageService',
  refineStateService
];

module.exports = (ngModule) => {
  ngModule.service('refineStateService', refineStateServiceArray);
};
